import ReactDOM from "react-dom";
import React from "react";
import Game from "game_play/model/score";
import ScoreView from "./score_view";
import ScoreTable from "./score_table";
import { createModels, withModels } from "game_play/utils/store";

const $scoreView = document.querySelector('#react-stats-avg');
const $scoreTable = document.querySelector('#react-score-table');

class GameView extends React.Component {
  componentDidMount() {
    const { Game } = this.props;
    this._unsubscribe = Game.subscribe()
    Game.fetch()
  }

  componentWillUnmount() {
    this._unsubscribe()
  }

  render() {
    return (
      <>
        {$scoreView && ReactDOM.createPortal(
          <ScoreView/>,
          $scoreView
        )}
        {$scoreTable && ReactDOM.createPortal(
          <ScoreTable/>,
          $scoreTable
        )}
      </>
    )
  }
}

export default createModels(withModels(GameView), {
  Game
}, {
  game: window.INIT_DATA || {}
})